var uris = [
  [1, require("/opt/buildhome/repo/js/login/firstscreen/icons/invest/meta.png?asset")],
  [2, require("/opt/buildhome/repo/js/login/firstscreen/icons/invest/meta@2x.png?asset")],
  [3, require("/opt/buildhome/repo/js/login/firstscreen/icons/invest/meta@3x.png?asset")]
];

module.exports = {
  get uri() {
    var ratio = (typeof window !== 'undefined' && window.devicePixelRatio) || 1;
    for (var i = 0; i < uris.length; i++) {
      if (uris[i][0] >= ratio) return uris[i][1];
    }
    return uris[uris.length - 1][1];
  },
  width: 49,
  height: 45,
  toString: function () {
    return this.uri;
  },
};
